import { render, staticRenderFns } from "./AdvertiserManageAdd.vue?vue&type=template&id=4dd33736&scoped=true&"
import script from "./AdvertiserManageAdd.vue?vue&type=script&lang=js&"
export * from "./AdvertiserManageAdd.vue?vue&type=script&lang=js&"
import style0 from "./AdvertiserManageAdd.vue?vue&type=style&index=0&id=4dd33736&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd33736",
  null
  
)

export default component.exports